import React from "react";
import CustomModal from "widgets/Modal/CustomModal";
import CustomTable from "widgets/Table/CustomTable";
import PrimaryButton from "widgets/Buttons/PrimaryButton";
import VerticalRegistry from "constants/verticalRegistry";
import HomeModule from "components/Home/Home.module.scss";

const MultipleStudentProfile = ({
  open,
  onClose,
  profiles,
  onSelectProfile,
}) => {
  const profileColumns = [
    {
      id: "name",
      label: "Name",
      render: (row) =>
        `${row.account.firstName || ""} ${row.account.lastName || ""}`.trim() ||
        "N/A",
    },
    {
      id: "vertical",
      label: "Business Vertical",
      render: (row) =>
        VerticalRegistry.getVertical(row.profile.verticalId)?.name ||
        row.profile.verticalId,
    },
    {
      id: "uamId",
      label: "UAM ID",
      render: (row) => row.profile.uamId || "N/A",
    },
    {
      id: "action",
      label: "Action",
      render: (row) => (
        <PrimaryButton onClick={() => onSelectProfile(row)}>
          Select
        </PrimaryButton>
      ),
    },
  ];

  return (
    <CustomModal
      open={open}
      onClose={onClose}
      title="Multiple Profiles Found"
      maxWidth="md"
      fullWidth={false}
    >
      <div
        className={HomeModule.modalSubtitle}
      >
        Multiple profiles exist for the provided details. Please select the
        required profile to continue.
      </div>
      <CustomTable
        columns={profileColumns}
        data={profiles}
        noDataMessage="No profiles found."
        sx={{ border: "none" }}
      />
    </CustomModal>
  );
};

export default MultipleStudentProfile;
